import { COLUMN_DATE_TIME, COLUMN_DATE, COLUMN_NAME, COLUMN_DISPLAY_NAME, COLUMN_TAG_CODE, COLUMN_SITE, COLUMN_DURATION, COLUMN_ENTRY_READER, COLUMN_EXIT_READER, COLUMN_DOOR, COLUMN_START_TIME, COLUMN_END_TIME, COLUMN_STATUS } from "../../constants/column-types";
import { FILTER_DATE, FILTER_ENTRY_TERMINAL, FILTER_PASS_TERMINAL, FILTER_FAIL_TERMINAL, FILTER_RESULT, FILTER_TIMEOUT_MINUTES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";
import { ColumnFormattingClasses } from "./constants/ColumnFormattingClasses";

const SequentialEventColumn: TableColumn[] = [
    {
        heading: "Display Name",
        accessor: "personName",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "cardNumber",
        columnId: COLUMN_TAG_CODE
    },
    {
        heading: "Start Time",
        accessor: "entryTime",
        isNumeric: false,
        id: 2,
        active: false,
        translationKey: "startTime",
        columnId: COLUMN_START_TIME
    },
    {
        heading: "Entry Device",
        accessor: "entryReader",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "entryDevice",
        searchOnName: "entryTerminalId",
        filterKey: "entryTerminalId",
        filterId: FILTER_ENTRY_TERMINAL,
        lookupName: "entryTerminalId",
        settingDataName: "deviceImprox",
        columnId: COLUMN_ENTRY_READER
    },
    {
        heading: "Entry Location",
        accessor: "entryLocation",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "entryLocation",
        columnId: COLUMN_DOOR
    },
    {
        heading: "Site Name",
        accessor: "siteName",
        isNumeric: false,
        id: 5,
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE
    },
    {
        heading: "Result",
        accessor: "result",
        isNumeric: false,
        id: 6,
        active: true,
        translationKey: "result",
        searchOnName: "result",
        filterKey: "result",
        filterId: FILTER_RESULT,
        lookupName: "result",
        columnId: COLUMN_STATUS,
        settingDataName: "result",
        valueFormatting: (value) => {
            if (value === "PASS" || value === "Pass") {
                return ColumnFormattingClasses.categoryGreen;
            } else if (value === "FAIL" || value === "INCOMPLETE" || value === "Fail" || value === "Incomplete") {
                return ColumnFormattingClasses.categoryRed;
            }
            return "";
        }
    },
    {
        heading: "Outcome Time",
        accessor: "outcomeTime",
        isNumeric: false,
        id: 7,
        active: false,
        translationKey: "outcomeTime",
        columnId: COLUMN_END_TIME
    },
    {
        heading: "Outcome Reader",
        accessor: "outcomeReader",
        isNumeric: false,
        id: 8,
        active: true,
        translationKey: "outcomeReader",
        filterTranslationKey: "passDevice",
        searchOnName: "passTerminalId",
        filterKey: "passTerminalId",
        filterId: FILTER_PASS_TERMINAL,
        lookupName: "passTerminalId",
        settingDataName: "deviceImprox",
        columnId: COLUMN_EXIT_READER
    },
    {
        heading: "Fail Device",
        accessor: "failReader",
        isNumeric: false,
        id: 10,
        active: false,
        translationKey: "failDevice",
        searchOnName: "failTerminalId",
        filterKey: "failTerminalId",
        filterId: FILTER_FAIL_TERMINAL,
        lookupName: "failTerminalId",
        settingDataName: "deviceImprox",
        isFilterOnlyColumn: true    
    },
    {
        heading: "Timeout",
        accessor: "timeoutMinutes",
        isNumeric: true,
        id: 11,
        active: false,
        translationKey: "timeoutMinutes",
        searchOnName: "timeoutMinutes",
        filterKey: "timeoutMinutes",
        filterId: FILTER_TIMEOUT_MINUTES,
        lookupName: "timeoutMinutes",
        settingDataName: "element",
        isFilterOnlyColumn: true
    },
    {
        heading: "Date",
        accessor: "dateOnly",
        isNumeric: false,
        id: 12,
        active: false,
        translationKey: "date",
        searchOnName: "dateOnly",
        filterId: FILTER_DATE,
        columnId: COLUMN_DATE,
        hideLookup: true,
        settingDataName: "date",
        isFilterOnlyColumn: true
    },
    {
        heading: "Test Duration (Secs)",
        accessor: "testDurationSecs",
        isNumeric: true,
        id: 9,
        active: false,
        translationKey: "testDurationSecs",
        columnId: COLUMN_DURATION
    }
];

export default SequentialEventColumn;
